<template>
  <HolterRequestDetail v-if="isRender" :data="holterRequestDetailData"/>
</template>

<script>
import HolterRequestDetail from "@/components/mock/common/HolterRequestDetail";
export default {
  data() {
    return {
      isRender: false,
      holterRequestDetailData: {}
    };
  },
  props: {
    requestDetailData: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  components: { HolterRequestDetail },
  methods: {
    findHolterDetail() {
      let api = this.getHolterRequestDetail;
      let success = this.getHolterRequestDetailSuccess;
      let error = this.getHolterRequestDetailError;
      this.apiCall(api, success, error);
    },
    getHolterRequestDetail(client){
      return client.apis.internalHolter.getHolterRequestDetailPOST({
        body: { receiptNumber: this.requestDetailData.receptionNumber }
      });
    },
    getHolterRequestDetailSuccess(result) {
      this.holterRequestDetailData = result.obj.applicationDetails;
      this.isRender = true;
    },
    getHolterRequestDetailError(error) {
      // this.showErrorMessage(error);
    },
  },
  created() {
    this.findHolterDetail();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/mock/philips/call/components/HolterRequestDetailCard.vue